<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader" />
      <rule-game :title="ruleTitle.rule" :value="ruleGame" />
      <rule-game :title="ruleTitle.button" :value="ruleButton" />
      <rule-game :title="ruleTitle.paytable" :value="rulePaytable" />
    </div>
  </div>
</template>
<script>
import Fsrule from '../../assets/gamerule/fruitslot/fruit_text1.png';
import Hrbanner from '../../assets/gamerule/horseracing/Hr_Banner.png';
import Hrstart from '../../assets/gamerule/horseracing/Icon_info_Start.png';
import Hrminus from '../../assets/gamerule/horseracing/Icon_info_Minus.png';
import Hrplus from '../../assets/gamerule/horseracing/Icon_info_Plus.png';
import Hrcancle from '../../assets/gamerule/horseracing/Icon_info_Cancle.png';
import Hrbutton from '../../assets/gamerule/horseracing/Hr_UI_Button_play.png';
import Hrnumber from '../../assets/gamerule/horseracing/icon_number.png';

export default {
  name: 'rule_horseracing',
  data() {
    return {
      ruleHeader: {
        gameName: 'ทุ่งรักนักตกปลา (Lets Fishing Field)',
        boardImg: Hrbanner,
      },
      ruleTitle: {
        button: 'Main Game',
        paytable: 'Symtable Payout Values',
      },
      ruleGame: [
        {
          image: Fsrule,
          type: 'imageNoborder',
          class: 'w-30 ml-3',
        },
        {
          type: 'textHrColor1',
          text: '-เมื่อเข้าเกมส์ผู้เล่นจะเห็นช่อง',
          textCol: ' COINS ',
          text2: 'คือ เงินที่เรามีใช้สำหรับเดิมพัน',
        },
        {
          type: 'textHrColor2',
          text: '-ในส่วนของ',
          textCol: ' LAST RESULT ',
          text2: 'คือผลลัพธ์ที่เคยออกมาแล้ว 5 อันดับ',
        },
        {
          type: 'textHrColor3',
          text: '-ในส่วนของ ',
          textCol: 'STARTER',
          text2: ',',
          textCol2: 'FINTSHER',
          text3: ',',
          textCol3: 'SPRINTER',
          text4: '  คือ คำใบ้ บอกว่าม้าตัวไหนมีโอกาศเข้าในตาต่อไปโดยเลขน้อยจะเข้าก่อนเลขมากเสมอ',
        },
        {
          type: 'textHrColor4',
          text: 'ผู้เล่นสามารถเลือก Symbol ที่ต้องการเดิมพัน แล้วกดปุ่ม START หลังจากนั้นม้าจะวิ่งออกไป ตัวที่เข้า 2 อันดับแรก คือ Score ที่ถูก หากผู้เล่นเดิมพันถูกจะได้รับเงิน',
          textCol: ' BET ',
          text2: 'X ',
          textCol2: 'อันตราต่อรอง(ODDS) ',
          text3: '= ผลลัพธ์',
        },
      ],
      ruleButton: [
        {
          type: 'ruleGame-horse',
          image: Hrstart,
          class: 'w-50',
          text: '-ปุ่มนี้เรียกว่า',
          textCol: ' START ',
          textCon: 'ใช้สำหรับเริ่มเกมส์หรือเริ่มเดิมพัน',
          image2: Hrminus,
          image3: Hrplus,
          text2: '-ปุ่มนี้เรียกว่า Minus/Plus แทนเป็นการหยอดเหรียญเข้าตู้ใช้สำหรับเพิ่มลดจำนวนเงิน BET ได้แก่ 1 5 10',
          image4: Hrcancle,
          class4: 'w-60',
          text3: '-ปุ่มนี้เรียกว่า Cancle ใช้สำหรับยกเลิกการ BET ทั้งหมด',
          image5: Hrbutton,
          class5: 'w-70',
          text4: '-ปุ่มนี้ไว้สำหรับเลือก เดิมพัน ตาม Symbol ที่ผู้เล่นต้องการเดิมพัน จะทำงานตาม Bet ที่เลือกไว้',
        },
      ],
      rulePaytable: [
        {
          type: 'rulePayout-horse',
          text: '-',
          textCol: 'ODDS ',
          text2: 'ราคาต่อรองในแต่ละตาจะไม่เท่ากันขึ้นอยู่กับว่า',
          textCol2: ' STARTER',
          text3: ',',
          textCol3: 'FINTSHER',
          text4: ',',
          textCol4: 'SPRINTER ',
          text5: 'ออกเลขอะไร เลขที่โอกาศออกเยอะราคาต่อรอง',
          textCol5: ' (ODDS) ',
          text6: 'จะน้อย เลขไหนโอกาศออกยากราคาต่อรอง',
          textCol6: ' (ODDS) ',
          text7: 'จะมาก',
          image: Hrnumber,
          class: 'w-60',
        },
      ],
    };
  },
};
</script>
